import { render, staticRenderFns } from "./CurrentEmployeeHistory.vue?vue&type=template&id=6b383616&scoped=true&"
import script from "./CurrentEmployeeHistory.vue?vue&type=script&lang=js&"
export * from "./CurrentEmployeeHistory.vue?vue&type=script&lang=js&"
import style0 from "./CurrentEmployeeHistory.vue?vue&type=style&index=0&id=6b383616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b383616",
  null
  
)

export default component.exports